import { BaseOutput, isBaseOutput } from './base-output.model'
import { has } from 'lodash'

export interface ChangeRegistrationCellAndSendSmsOutput extends BaseOutput {
  /* eslint-disable @typescript-eslint/naming-convention */
  PhoneNumber?: string
  PhonePrefix?: string
  DateTimeNextRequestIsAvailable?: string
  /* eslint-enable @typescript-eslint/naming-convention */
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isChangeRegistrationCellAndSendSmsOutput = (obj: any): obj is ChangeRegistrationCellAndSendSmsOutput => {
  const phonePrefix = 'PhonePrefix'
  const phoneNumber = 'PhoneNumber'
  const dateTimeNextRequestIsAvailable = 'DateTimeNextRequestIsAvailable'

  return isBaseOutput(obj) && has(obj, phoneNumber) && has(obj, phonePrefix) && has(obj, dateTimeNextRequestIsAvailable)
}
